module.exports = __webpack_public_path__ + "static/media/trial2_3.0840e168.png";